import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { DateTime } from 'luxon'

import { selectActiveReportByReportId } from '@/selectors/reportSelectors'
import { useReselector } from '@/utils/sharedHooks'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { fetchBookkeepingReports } from '@/actions/bookkeepingReportActions'
import { useAppDispatch } from '@/utils/typeHelpers'

export const BookkeepingReportReroute = () => {
  const dispatch = useAppDispatch()
  const { bookkeepingReportId } = useParams()

  const activeReport = useReselector(
    selectActiveReportByReportId,
    bookkeepingReportId
  )

  useEffect(() => {
    const fetch = async () => {
      await dispatch(fetchBookkeepingReports())
    }
    fetch()
  }, [dispatch])

  if (activeReport) {
    return (
      <Navigate
        to={`/reports/bookkeeping/${DateTime.fromFormat(activeReport.date, DATE_FORMATS_LUXON.YEAR_MONTH).toFormat(DATE_FORMATS_LUXON.MONTH_ZERO_PADDED)}/${DateTime.fromFormat(activeReport.date, DATE_FORMATS_LUXON.YEAR_MONTH).toFormat(DATE_FORMATS_LUXON.YEAR_FOUR_DIGIT)}/overview`}
        replace
      />
    )
  }

  return null
}
